import { SettingsItem } from '@/model/SettingsItem'
import { SettingsResponse } from '@/types/service-response'
import store from '@/store'
import { SETTINGS_REPLACE } from '@/store/mutation-types'
import { SETTINGS_ALL } from '@/store/getter-types'
import axios from '@/plugins/axios'

const parseTypeMap = {
  'boolean': parseBooleanValue
}

export function createModelFromResponse (data: SettingsResponse): SettingsItem[] {
  return data.map((i) => {
    const value = parseValue(i.value, i.type)

    return new SettingsItem(i.key, value, i.type)
  })
}

export function replace (payload: SettingsItem[]): void {
  store.commit(SETTINGS_REPLACE, payload)
}

export function getSetting (key: string): SettingsItem | null {
  const settings = store.getters[SETTINGS_ALL]

  return settings.find((i: SettingsItem) => i.key === key)
}

export function setSetting (key: string, value: boolean) {
  const settingItem = getSetting(key)

  const newItem = new SettingsItem(key, value, settingItem!.type)

  const settings: SettingsItem[] = store.getters[SETTINGS_ALL]
  const idx = settings.findIndex((i) => i.key === key)

  settings.splice(idx, 1, newItem)
}

// setSetting only mutates the local store; this one also writes the value
// to the server and replaces the store with the persisted state.
export async function persistBooleanSetting (key: string, value: boolean): Promise<void> {
  const response = await axios.put('/api/account/settings', [
    { key, type: 'boolean', value: value ? 'true' : 'false' }
  ])

  replace(response.data)
}

// Tenant settings a boarder may see (allowlisted server-side).
export async function fetchAutomaticOrderingEnabled (): Promise<boolean> {
  const response = await axios.get('/api/account/tenant-settings')
  const item = (response.data as Array<{ key: string, value: string | null }>)
    .find((i) => i.key === 'tenant.automatically_reserve_all')

  return item?.value === 'true'
}

function parseValue (value: string, type: string): boolean | number | string {
  const t = type.toLowerCase()

  //@ts-ignore
  if ((parseTypeMap[t] as any)) {
    //@ts-ignore
    return parseTypeMap[t](value)
  }

  return value
}

function parseBooleanValue (value: string): boolean {
  return value.toLowerCase().trim() === 'true'
}
